import { useLoggedOutSuppliersPageCurrentCategory } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/Context/useLoggedOutSuppliersPageCurrentCategory";
import { useIsLoggedOutSuppliersLayoutElementLoading } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/LoggedOutSuppliersLayoutElement/useIsLoggedOutSuppliersLayoutElementLoading";
import { useLoggedOutSuppliersLayoutElements } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/LoggedOutSuppliersLayoutElement/useLoggedOutSuppliersLayoutElements";
import { LoggedOutSuppliersPageLayoutElementRenderer } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageLayoutElements/__internal__/LoggedOutSuppliersLayoutElementRenderer";
import { SuppliersPageLoadingSkeleton } from "@faire/retailer-visitor-shared/views/suppliers/SuppliersPageLoadingSkeleton/SuppliersPageLoadingSkeleton";
import { trackLoggedOutRetailersSupplierPageBottomCarouselView } from "@faire/web-api--source/events/loggedOutRetailers/view/supplierPageBottomCarousel";
import { trackSeoSuppliersPageMostPopularCarouselView } from "@faire/web-api--source/events/seo/view/suppliersPageMostPopularCarousel";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import React from "react";

export const LoggedOutSuppliersPageLayoutElements: React.FC<{
  type: Array<keyof typeof ILayoutElement.Type | undefined>;
}> = ({ type }) => {
  const categoryModel = useLoggedOutSuppliersPageCurrentCategory();
  const categoryPathIdentifier = categoryModel?.mostSpecificPathIdentifier;
  const isLoading = useIsLoggedOutSuppliersLayoutElementLoading();

  const layoutElements = useLoggedOutSuppliersLayoutElements();

  const getTrackEvent = (
    layoutElementType: keyof typeof ILayoutElement.Type | undefined
  ) => {
    switch (layoutElementType) {
      case ILayoutElement.Type.MOST_POPULAR_BRANDS:
        return trackSeoSuppliersPageMostPopularCarouselView;
      default:
        return () =>
          trackLoggedOutRetailersSupplierPageBottomCarouselView(
            `C${categoryPathIdentifier}`
          );
    }
  };

  if (isLoading) {
    return <SuppliersPageLoadingSkeleton />;
  }

  if (layoutElements === undefined) {
    return null;
  }
  const filteredLayoutElements = layoutElements.filter((layoutElement) =>
    new Set(type).has(layoutElement.type)
  );
  return (
    <>
      {filteredLayoutElements.map((layoutElement, index) => (
        <LoggedOutSuppliersPageLayoutElementRenderer
          key={`logged-out-suppliers-page-carousel-${layoutElement.type}-${index}`}
          layoutElement={layoutElement}
          onVisible={getTrackEvent(layoutElement.type)}
        />
      ))}
    </>
  );
};
